import type { ScaleLinear } from 'd3-scale';

/**
 * @param rangeMin - The minimum range
 * @param rangeMax - The maximum range
 * @param scale - The scale (e.g. 5, 10, 1)
 * @returns The display values (e.g. [0, 5, 10, 15, 20])
 */
export const getDisplayValues = (
  rangeMin: number,
  rangeMax: number,
  scale: number,
): Array<number> => {
  const length = Math.floor((rangeMax - rangeMin) / scale) + 1;
  return Array.from({ length }, (_, i) => rangeMin + i * scale);
};

/**
 * Get the adjusted positions of the correct range on the x-axis
 */
export const getCorrectRangePositions = (
  xScale: ScaleLinear<number, number>,
  correctValue: number,
  correctRange: { min: number; max: number } | undefined,
  tickWidth: number,
  rangeMin: number,
  rangeMax: number,
) => {
  const correctAnswerMin = correctRange?.min ?? correctValue;
  const correctAnswerMax = correctRange?.max ?? correctValue;

  const isCorrectAnswerMinOnEdge = correctAnswerMin <= rangeMin;
  const isCorrectAnswerMaxOnEdge = correctAnswerMax >= rangeMax;

  const startOffset =
    isCorrectAnswerMinOnEdge || correctRange ? 0 : -tickWidth / 2;
  const endOffset =
    isCorrectAnswerMaxOnEdge || correctRange ? 0 : tickWidth / 2;

  const chartWidth = xScale.range()[1]!;

  const startX = xScale(correctAnswerMin) + startOffset;
  const endX = Math.min(xScale(correctAnswerMax) + endOffset, chartWidth);

  return {
    startX,
    endX,
    width: endX - startX,
  };
};
